/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Softskills_Placeholder1Inputs */

const en_job_form_softskills_placeholder1 = /** @type {(inputs: Job_Form_Softskills_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamwork, communication...`)
};

const de_job_form_softskills_placeholder1 = /** @type {(inputs: Job_Form_Softskills_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamfähigkeit, Kommunikation…`)
};

/**
* | output |
* | --- |
* | "Teamwork, communication..." |
*
* @param {Job_Form_Softskills_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_softskills_placeholder1 = /** @type {((inputs?: Job_Form_Softskills_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Softskills_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_softskills_placeholder1(inputs)
	return en_job_form_softskills_placeholder1(inputs)
});
export { job_form_softskills_placeholder1 as "job_form_softSkills_placeholder" }